import React, { useEffect, useState, useContext } from "react"
import { Context } from "../../components/store/UserProvider"
import axios from "axios"

const useGetComments = videoId => {
  const ctx = useContext(Context)
  const readUserComments =
    "f5524c7172146e0a641eaa6a9674730b26b016c9b68917affb0e72f8f33c6df2fb05f4627a44c7d6d9d0f66a1ff9921a61ba0f1c670623e642485e12823b9c75a54a30e22bb9b9e90672c196ebc01ff6766668ffa7c96ab7d14621079fd79ff55edeacdd8dfcb7f3fde3d21b1d0e82e823f35fed1d9d67a8a3918316459d89b5"

  const [commentData, setCommentData] = useState(null)
  // const test = null

  useEffect(() => {
    let comments
    axios
      .get(
        `https://montessori-back.herokuapp.com/api/lessons/${videoId}?populate=comments`,
        {
          headers: {
            Authorization: `Bearer ${readUserComments}`,
          },
        }
      )
      .then(response => {
        setCommentData(response.data.data.attributes.comments.data)
        if (ctx.navToNewPost) {
          comments = response.data.data.attributes.comments.data
        }
      })
      .catch(error => {
        console.log(error.response)
      })
      .finally(() => {
        if (ctx.navToNewPost) {
          const ids = comments.map(comment => {
            return comment.id
          })
          const latestId = Math.max(...ids)

          if (typeof document !== `undefined`) {
            const latestComment = document.getElementById(`${latestId}`)
            latestComment.scrollIntoView({
              behavior: "auto",
              block: "center",
              inline: "center",
            })
          }
          ctx.setNavToNewPost(null)
        }
      })
  }, [ctx.refreshCommetnsCounter])

  return {
    commentData,
  }
}

export default useGetComments
